import type { FormInstance } from "antd/es/form/hooks/useForm"
import type { BaseOptionType } from "antd/lib/select"
import React from "react"

import {
  ProjectTypeSelect,
  type ProjectTypeSelectProps
} from "../../../../../../components/Shared/ProjectTypeSelect.tsx"
import type {
  ProjectFormData,
  ProjectFormDataPhase
} from "../../project-form-data.ts"

interface ProjectDetailsSectionProjectTypeProps {
  form: FormInstance<ProjectFormData>
  initialOptions: BaseOptionType[]
  value?: string[]
  onTypeNamesChange?: (names: Record<string, string>) => void
}

export function ProjectDetailsSectionProjectType({
  form,
  initialOptions = [],
  value,
  onTypeNamesChange
}: ProjectDetailsSectionProjectTypeProps) {
  const onSelectProjectTypes: ProjectTypeSelectProps["onChange"] = (
    ids,
    data
  ) => {
    if (!data) return

    const types = Array.isArray(data) ? data : [data]

    onTypeNamesChange?.(
      Object.fromEntries(types.map((t) => [t?.value, t?.label]))
    )

    const phases: ProjectFormDataPhase[] =
      form.getFieldValue("project_phases") || []

    const existingPhasesById = new Map(phases.map((p) => [p?.id, p]))

    const phasesByProjectType = new Map<number, ProjectFormDataPhase[]>()
    for (const p of phases) {
      if (p?.project_type) {
        const arr = phasesByProjectType.get(p.project_type as any) || []
        arr.push(p)
        phasesByProjectType.set(p.project_type as any, arr)
      }
    }

    const newMilestones: ProjectFormDataPhase[] = []

    for (const t of types) {
      const typeId = t?.value
      const existPhases = phasesByProjectType.get(typeId as any)

      if (existPhases?.length) {
        newMilestones.push(...existPhases)
      } else {
        const templatePhases = t?.data?.phases || []
        for (const phase of templatePhases) {
          const existing = existingPhasesById.get(phase?.id)

          if (existing) {
            newMilestones.push(existing)
          } else {
            newMilestones.push({
              ...phase,
              id: `_${phase?.id}`,
              budget: { budget: phase?.default_budget || 0 },
              checklist_data: phase?.checklist_items_primitive
            } as ProjectFormDataPhase)
          }
        }
      }
    }

    const activeProjectTypeId = form.getFieldValue("activeProjectTypeId")

    // Batch updates
    form.setFieldsValue({
      activeProjectTypeId: ids?.includes(activeProjectTypeId)
        ? activeProjectTypeId
        : ids?.[0],
      project_phases: newMilestones,
      project_type: ids
    })
  }

  return (
    <ProjectTypeSelect
      value={value}
      initialOptions={initialOptions}
      mode={"multiple"}
      onChange={onSelectProjectTypes}
    />
  )
}
